import { render, staticRenderFns } from "./Eprojectrecords.vue?vue&type=template&id=af4bc33c&scoped=true"
import script from "./Eprojectrecords.vue?vue&type=script&lang=js"
export * from "./Eprojectrecords.vue?vue&type=script&lang=js"
import style0 from "./Eprojectrecords.vue?vue&type=style&index=0&id=af4bc33c&prod&lang=css"
import style1 from "./Eprojectrecords.vue?vue&type=style&index=1&id=af4bc33c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4bc33c",
  null
  
)

export default component.exports